import { ThunkDispatch } from '@reduxjs/toolkit'
import CartSlice from '../storage/cart.slice'
import { CartAPIError, ErrorCode } from '../storage/cart.types'

export const ErrorMessage = {
  [ErrorCode.ValidationError]:
    'We’re sorry, but an unexpected error has occurred. Don’t worry, it’s not you - it’s us.\nPlease try again later.',
  [ErrorCode.InvalidStore]:
    'We’re sorry, but an unexpected error has occurred. Don’t worry, it’s not you - it’s us.\nPlease try again later.',
  [ErrorCode.InvalidProduct]:
    'Heads up! Some of the items in your cart are unavailable. We have removed these items from your order. Please review your order before re-submitting.',
  [ErrorCode.PricesMismatch]:
    'Heads up! Our prices have been updated. Please double-check the new prices before re-submitting your order.',
  [ErrorCode.InvalidCart]:
    'Uh oh! Looks like your cart is out of date. Please refresh the page in order to continue.',
  [ErrorCode.OfflineError]:
    'It appears you are currently offline. Internet connectivity is required to submit your order. Please try re-submitting your order once you are back online.',
  [ErrorCode.CSU]:
    'We’re sorry, but an unexpected error has occurred. Don’t worry, it’s not you - it’s us.\nPlease try again later.',
  unknown:
    'We’re sorry, but an unexpected error has occurred. Don’t worry, it’s not you - it’s us.\nPlease try again later.',
}

export const handleErrors = (
  accountNumber: string,
  err: CartAPIError,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch?: ThunkDispatch<unknown, unknown, any>,
) => {
  if (dispatch && err.type === ErrorCode.InvalidCart) {
    dispatch(
      CartSlice.actions.clearCart({
        accountNumber,
      }),
    )
  }
  if (dispatch && err.type === ErrorCode.InvalidProduct && err.unavailableProducts) {
    dispatch(
      CartSlice.actions.removeItems({
        accountNumber,
        products: err.unavailableProducts,
      }),
    )
  }
  if (dispatch && err.type === ErrorCode.PricesMismatch && err.priceChanges) {
    dispatch(
      CartSlice.actions.updateItemsPrice({
        accountNumber,
        products: err.priceChanges,
      }),
    )
  }
  return ErrorMessage[err.type ?? 'unknown']
}
